import { Stack, StackProps } from '@mui/material'

export const StackForm = (stackProps: StackProps): JSX.Element => (
  <Stack
    {...stackProps}
    alignItems='center'
    direction='row'
    flexWrap='wrap'
    gap={2}
    pt={1}
  />
)
